<script>
	import { margCorrect,formSubmitted,formEntries, scrollTrigger } from './stores.js';

	let submitPromise;
	let submitted = false;

	export let cols;

	let margx = 200;

	let maxlength = {
		response:150,
		name:30,
		location:30
	}

	let input = {
		col:null,
		text:'',
		name:'',
		location:'',
		email:''
	};

	let focus_timer = null;

	const email = false;

	const handleClick = (e,i) => {

		if (e.type == 'keypress') {
			const code = e.charCode || e.keyCode;
			if (code != 32 && code != 13) return;
		}

		input['col'] = i;

	}

	const handleOnSubmit = () => {

		if (__myapp.env.isProd) {
			submitPromise  = submitForm();
		}
		else {
			formSubmitted.set(true);

			//// testing /////
			formEntries.set({
				Authorid: "999", 
				Author: "anonymous", 
				Reason:`new entry! (fake)`,
				Published: "1", 
				Location:"earth",
				Colour: 0,
				Submitted: "2021-04-20 12:00:00"
			})
			submitted = true;
		}
	}

	const submitForm = async () => {

		console.log('submitForm');
		console.log(input['col']);
		console.log(parseInt((cols.length-2)*Math.random()+0.5))

		if (input['col'] == null) {
			input['col'] = parseInt((cols.length-2)*Math.random()+0.5);
		}
		// if (input['name'] == null) {
		// 	input['name'] = "";
		// }

		let formData = new FormData();

		formData.append('name', input['name']);
		formData.append('response', input['text']);
		formData.append('location', input['location']);
		formData.append('email', input['email']);
		formData.append('col', input['col'] );
		
		const response = await fetch(`../response.php`, {
			method: 'post',
			body: formData
		});

		if (response.status === 200) {

			submitted = true;

			// for starfield
			formSubmitted.set(submitted);

			// for wall
			formEntries.set({
				Authorid: "new", 
				Author: input['name'], 
				Reason:input['text'],
				Published: "1", 
				Location:input['location'],
				Colour: `${input['col'] }`
			})

			return await response.json();
		} else {
			throw new Error(response.statusText);
		}
	}

	const unsubscribe_marg = margCorrect.subscribe(obj => {
		margx = obj.margx;
	});

	const unsubscribe_scrollTrigger = scrollTrigger.subscribe(value => {
		if (value == false) return;

		clearTimeout(focus_timer);
		focus_timer = setTimeout(() => {document.getElementById('fres').focus()},200);
	});

</script>

	<svg viewBox="0 0 100 100" style="display:none;">
		<defs>
		  <g id="cube">
		   <path d="
		   M20 50 L80 50
		   M50 20 L50 80

		   M25 25 L75 75
		   M75 25 L25 75
		   "/>
		  </g>
		</defs>
	</svg>
	
	<section style={`padding:${20}px ${0.5*margx}px;`}>

		<div class="formHolder">

			{#if submitted}
				{#await submitPromise}
					<p>...submitting</p>
				{:then json}
					<div class="formHolder">
						<!-- {#if json.status == 'success'} -->
							<h1>Your submission has been received!</h1>
						<!-- {:else} -->
							<!-- <p style="color: red">{json.msg}</p> -->
						<!-- {/if} -->
					</div>
				{:catch error}
					<div class="formHolder">
						<p style="color: red">{error.message}</p>
					</div>
				{/await}
			{:else}
				<form on:submit|preventDefault={handleOnSubmit}>
					<div class="pd">
						<div><label id="fres_label" for="fres">Enter your response below ({maxlength.response - input['text'].length} remaining)</label></div>
						<textarea class="textarea boxsizingBorder" id="fres" name="fres" aria-labelledby="fres_label" placeholder="type your response here" required maxlength="{maxlength.response}" bind:value={input['text']}></textarea>
					</div>
					<div class="pd">
						<div><label id="fname_label" for="fname">Enter a name we can display with your response ({maxlength.name - input['name'].length} remaining)</label></div>
						<input type="text" id="fname" name="fname" aria-labelledby="fname_label" placeholder="what is your name?" bind:value={input['name']} style="width:300px" maxlength="{maxlength.name}">
					</div>
					<div class="pd">
						<div><label id="floc_label" for="floc">Enter a location we can display with your response ({maxlength.location - input['location'].length} remaining)</label></div>
						<input type="text" id="floc" name="floc" aria-labelledby="floc_label" bind:value={input['location']} placeholder="where are you from?" style="width:300px" maxlength="{maxlength.location}">
					</div>
					{#if email}
						<div class="pd">
							<div><label id="email_label" for="email" >Enter your email</label></div>
							<input type="email" id="email" name="email" aria-labelledby="email_label"  placeholder="you@email.com" bind:value={input['email']}>
						</div>
					{/if}
					<div id="section4" class="pd">
						<div>Choose your tape colour.</div>
						<div class="pd">
							{#each cols as col,i}
								{#if i != cols.length-1}
									<svg viewBox="0 0 100 100" width="50px" on:click={(e) => {handleClick(e,i);}} on:keypress={(e) => {handleClick(e,i);}} tabindex="0" class="{input['col'] === i ? `active` : ``}" style="stroke:{cols[i]['hex']} ">
										<title>{`Select tape (${cols[i]['desc']})`}</title>
										<desc>{`Select this option to have your response displayed using ${cols[i]['desc']} duct tape.`}</desc>
										<use xlink:href="#cube" x="0" y="0"/>
									</svg>
								{/if}
							{/each}
						</div>
					</div>

					<!-- on:focus={() => {input['col'] = i;}} -->
					
					<div class="pd">
						<button class="btn" type="submit">
							Submit
						</button>
					</div>
					<div class="pd">
					The <em>I Am Getting Vaccinated Because</em> project privileges honest, compassionate, curious, and mindful participation and storytelling.  CK Public Health and IAGVB partners reserve the right to remove any submissions to the online platform that is in antithesis to these ideals, and is inappropriate in its message.  Public Health is a humble practice that we all have a role in.  Let’s lead with kindness, and tell our triumphant story with respect for each other.
					</div>
				</form>
			{/if}
		</div>

	</section>

<style>

	.pd {padding:10px 0;}

	.formHolder {
		text-align: left;
		/*padding: 1em;*/
		max-width: 640px;
		/*border: 1px solid #aaa;
		border-radius:5px;*/

		padding-bottom: 300px;

		/*background-color:red;*/
	}

	.textarea {
		 width:100%;
		 height:150px;
		 padding:10px;
	}

	.redtxt {
		color:red;
	}
	svg {
		opacity:0.6;
		stroke-width:10px;
		fill: transparent;
		cursor:pointer;
		transform: rotate(90deg);
	}

	svg:hover {
		opacity:1;
		transform: scale(1.2)
	}

	.active {
		opacity:1;
		/*box-shadow: 0px 0px 2px 2px #888888;*/
	}

	#fname {
		 padding:10px;
	}

	button {
	  display: inline-block;
	  text-align: center;
	  text-decoration: none;

	  border-radius: 10px;
	  padding:6px; 

	  cursor:pointer;
	  width:auto;
	}

	.btn {
		color: #fff;
	 	background: #000;
		border: solid 2px white;
	}

	button:focus {
	 	color: #000;
	 	background: #fff;
		border: solid 2px black;
	}

	button:hover {
		color: #000;
	 	background: #fff;
		border: solid 2px black;
	}

	.boxsizingBorder {
    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
            box-sizing: border-box;
	}

	label {padding:10px 0;}

</style>